import type { MonthlyFilters, MonthlyUsageDTO } from '../../usage.types';
import type IMonthlyUsageRepository from '../IMonthlyUsageRepository';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';
import qs from 'qs';
import { injectable } from 'inversify';
import 'reflect-metadata';

@injectable()
export class MonthlyUsageRepository implements IMonthlyUsageRepository {
  async create(/* data: unknown */): Promise<MonthlyUsageDTO> {
    throw new Error('Method not implemented.');
  }
  async getList(queries?: MonthlyFilters): Promise<Page<MonthlyUsageDTO>> {
    const queryString = qs.stringify(queries);

    const result = await API.get<Page<MonthlyUsageDTO>>(`/api/v1/monthly-usages?${queryString}`);
    return result.data;
  }
}
